import {Tile, TileProps} from "../components/Tile.tsx";
import {Box, Stack} from "@mui/joy";
import {Surcharge} from "../rpc/webrpc-client.gen.ts";
import {useTranslation} from "react-i18next";
import {useUnitArmap} from "../tq/tqx.tsx";

export interface SurchargeTileProps extends Omit<TileProps, "children"> {
    surcharge: Surcharge;
}

export function SurchargeTile({surcharge, ...rest}: SurchargeTileProps) {
    const {t} = useTranslation();
    const {data: units} = useUnitArmap();
    const unitName = units?.byId.get(surcharge.flavor.unitId)?.displayName;
    return <Tile key={surcharge.id}
                 Subject={(props) =>
                     <Box {...props}>{surcharge.flavor.displayName}</Box>}
                 {...rest}>
        <Stack direction="column" sx={{alignItems: "center"}}>
            <Stack direction="row" sx={{width: "95%", justifyContent: "space-between"}}>
                <Stack direction="row" spacing={1.2}>
                    <Box>{surcharge.quantity}</Box>
                    <Box>{unitName}</Box>
                </Stack>
                {surcharge.cost
                    ? <Stack direction="row" spacing={1.2}>
                        <Box>{surcharge.cost}</Box>
                        <Box>{t("costUnit")}</Box>
                    </Stack>
                    : null}
            </Stack>
        </Stack>
    </Tile>
}


